import { setAnalytics } from "../actions/analytics.action";
import update from "immutability-helper";
/**
 * reducer for changes to interface settings
 */
const settingsReducer = {
    reducers: {
        [setAnalytics]: (state, payload) => update(state, { enabled: { $set: payload } }),
    },
    defaults: {
        enabled: undefined, // TODO, set me to false
    },
};
export default settingsReducer;
